import { DayPreset, RangePreset } from '../../types/types';
import { isValidDate } from '../helpers';
import { getRangeForTimespan } from './getRangeForTimespan';
import { getDateString } from './getDateString';

export const getDefaultDateFilterValues = (filter) => {
  let values: string[] = [];
  if (filter.defaultNamedRange) {
    let range = getRangeForTimespan(filter.defaultNamedRange);
    if (!range.from) {
      range = getRangeForTimespan(
        filter.type === 'DATERANGE'
          ? RangePreset.CURRENT_WEEK
          : DayPreset.CURRENT_DAY
      );
    }
    if (filter.type === 'DATERANGE' && range.from && range.to) {
      values = [getDateString(range.from), getDateString(range.to)];
    } else if (filter.type === 'DATE' && range.from) {
      values = [getDateString(range.from)];
    }
  } else if (
    filter.defaultValue &&
    Array.isArray(filter.defaultValue) &&
    ((filter.type === 'DATE' && filter.defaultValue.length === 1) ||
      (filter.type === 'DATERANGE' && filter.defaultValue.length === 2)) &&
    filter.defaultValue.every((dateString) => isValidDate(dateString))
  ) {
    values = filter.defaultValue;
  } else if (filter.type === 'DATE') {
    const range = getRangeForTimespan(DayPreset.CURRENT_DAY);
    if (range.from) {
      values = [getDateString(range.from)];
    }
  } else {
    const range = getRangeForTimespan(RangePreset.CURRENT_WEEK);
    if (range.from && range.to) {
      values = [getDateString(range.from), getDateString(range.to)];
    }
  }
  return values;
};
